import React from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import EmployeeImage from "./EmployeeImge";
import './employee_modal_style.scss';
import {Button} from "semantic-ui-react";

class EmployeeModal extends React.Component {

  toggle = () =>{}

  render() {

    let data = this.props.data;

    let image = "";
    let name = "";
    let slotId = 0;
    let designation = "";
      if(data) {
      image = data.slotActivation.photoPath;
      name = data.slotActivation.firstName + " " + data.slotActivation.lastName;
      slotId = data.slotActivation.slotNumber;
      designation = data.slotActivation.designation;
    }

    return(
      <div>
        <MDBModal isOpen={this.props.isOpen} toggle={this.toggle} size="md">
          <MDBModalHeader className={"title"}
                          toggle={this.props.closeModal}>Employee Details</MDBModalHeader>
          <MDBModalBody>

            <div>
              <table>
                <tr>
                  <td>Date</td>
                  <td>: { " " }{ this.props.date }</td>
                </tr>
                <tr>
                  <td>Slot</td>
                  <td>: { " " }{ slotId }</td>
                </tr>
              </table>
            </div>
            <div className={'text-center'}>
              <EmployeeImage image={ image }/>
            </div>
            <div>
              <table className={'employee-details'}>
                <tr>
                  <td>Reserved by</td>
                  <td>: { " " }{ name }</td>
                </tr>
                <tr>
                  <td>Designation</td>
                  <td>: { " " }{ designation }</td>
                </tr>
              </table>
            </div>
            <div className={'text-right'}>
              <Button
                className="px-5"
                onClick={()=>this.props.closeModal()}
              >
                Close
              </Button>
            </div>
          </MDBModalBody>
        </MDBModal>
      </div>
    )
  }
}

export default EmployeeModal;
